import EsEnums from './EsEnum'

/**
 * 是/否枚举
 * @type {EsEnum}
 */
const Enum = {
    //SCIP
    // ArticleCategory: new EsEnums({ONE:{ name: '59069910 .浸渍、涂覆、覆盖或层压纺织织物的纺织品和纺织制品', index: 93495 },TWO: { name: '630231 -纺织品和纺织制品>其他纺织制成品;集;破旧的衣物及纺织品', index: 100727 }}),
    OtherNameType: new EsEnums({
        BRAND: {name: '品牌', index: "66247"},
        MODEL: {name: '模型', index: "66248"},
        TYPE: {name: '类型', index: "66249"},
        OTHER: {name: '其他', index: "1342"}
    }),
    PrimaryArticleIdentifierType: new EsEnums({
        ECHA: {name: 'scip编号', index: "66297"},
        GTIN: {name: 'GTIN (全球交易品项识别代码)', index: "66298"},
        EAN: {name: 'EAN (欧洲商品编号)', index: "66299"},
        GPC: {name: 'GPC (通用产品代码)', index: "66300"},
        JAN: {name: 'JAN (日本商品号码)', index: "66301"},
        UDI: {name: 'UDI (唯一设备标识)', index: "66302"},
        ISBN: {name: 'ISBN (国际标准书号)', index: "66303"},
        CATALOGUE: {name: '产品样本号', index: "66304"},
        BATCH: {name: '批号', index: "66305"},
        PART: {name: '零件号码', index: "66306"},
        ITEM: {name: '产品编号', index: "66307"},
        REFERENCE: {name: '参考号', index: "66308"},
        SERIAL: {name: '序列号', index: "66309"},
        OTHER: {name: '其他:', index: "1342"}
    }),
    PrimaryArticleIdentifierTypeRefType: new EsEnums({
        ECHA: {name: 'scip编号', index: "66297"},
        // GTIN: {name: 'GTIN (全球交易品项识别代码)', index: "66298"},
        // EAN: {name: 'EAN (欧洲商品编号)', index: "66299"},
        // GPC: {name: 'GPC (通用产品代码)', index: "66300"},
        // JAN: {name: 'JAN (日本商品号码)', index: "66301"},
        // UDI: {name: 'UDI (唯一设备标识)', index: "66302"},
        // ISBN: {name: 'ISBN (国际标准书号)', index: "66303"},
        // CATALOGUE: {name: '产品样本号', index: "66304"},
        // BATCH: {name: '批号', index: "66305"},
        // PART: {name: '零件号码', index: "66306"},
        // ITEM: {name: '产品编号', index: "66307"},
        // REFERENCE: {name: '参考号', index: "66308"},
        // SERIAL: {name: '序列号', index: "66309"},
        // OTHER: {name: '其他:', index: "1342"}
    }),
    ProductionInEuropeanUnion: new EsEnums({
        BOTHEU: {name: '即是欧盟生产也是欧盟进口', index: "108023"},
        EUImported: {name: '欧盟进口', index: "108022"},
        EUProduced: {name: '欧盟出口', index: "108021"},
        NoData: {name: '无数据', index: "58236"}
    }),
    UnitscipHLWD: new EsEnums({
        METER: {name: 'm', index: "66310"},
        DECIMETER: {name: 'dm', index: "66311"},
        CENTIMETER: {name: 'cm', index: "66312"},
        MILLIMETER: {name: 'mm', index: "2120"}
    }), //Height, Length, Width, Diameter
    UnitscipDensity: new EsEnums({
        KGM3: {name: 'kg/m³', index: "2022"},
        KGDM3: {name: 'kg/dm³', index: "66313"},
        GCM3: {name: 'g/cm³', index: "1929"}
    }), //Density
    UnitscipWeight: new EsEnums({
        TON: {name: 't', index: "66314"},
        KG: {name: 'kg', index: "58374"},
        G: {name: 'g', index: "58373"},
        MG: {name: 'mg', index: "64929"}
    }), //Weight
    UnitscipVolume: new EsEnums({
        CUBICMETERS: {name: 'm3', index: "58376"},
        CUBICDECIMETER: {name: 'dm3', index: "66315"},
        CENTIMETER: {name: 'cm3', index: "58375"}
    }), //Volume
    Colour: new EsEnums({
        COLOURLESS: {name: '无色', index: "64912"},
        BLACK: {name: '黑色', index: "64913"},
        BLUE: {name: '蓝色', index: "64914"},
        BROWN: {name: '棕色', index: "64915"},
        GOLD: {name: '金色', index: "64916"},
        GREEN: {name: '绿色', index: "64917"},
        GREY: {name: '灰色', index: "64918"},
        ORANGE: {name: '橙色', index: "64919"},
        PINK: {name: '粉色', index: "64920"},
        PURPLE: {name: '紫色', index: "64921"},
        RED: {name: '红色', index: "64922"},
        SILVER: {name: '银色', index: "64923"},
        VIOLET: {name: '紫罗兰色', index: "64924"},
        WHITE: {name: '白色', index: "64925"},
        YELLOW: {name: '黄色', index: "64926"}
    }), //Colour
    Language: new EsEnums({
        BULGARIAN: {name: 'Bulgarian', index: "3601"},
        CROATIAN: {name: 'Croatian', index: "3633"},
        CZECH: {name: 'Czech', index: "3609"},
        DANISH: {name: 'Danish', index: "3611"},
        DUTCH: {name: 'Dutch', index: "355"},
        ENGLISH: {name: 'English', index: "3615"},
        ESTONIAN: {name: 'Estonian', index: "3618"},
        FINNISH: {name: 'Finnish', index: "3621"},
        FRENCH: {name: 'French', index: "3624"},
        GERMAN: {name: 'German', index: "3612"},
        GREEK: {name: 'Greek', index: "3614"},
        HUNGARIAN: {name: 'Hungarian', index: "3634"},
        ICELANDIC: {name: 'Icelandic', index: "3640"},
        IRISH: {name: 'Irish', index: "3626"},
        ITALIAN: {name: 'Italian', index: "3641"},
        LATVIAN: {name: 'Latvian', index: "3659"},
        LITHUANIAN: {name: 'Lithuanian', index: "3658"},
        MALTESE: {name: 'Maltese', index: "3668"},
        NORWEGIAN: {name: 'Norwegian', index: "3673"},
        POLISH: {name: 'Polish', index: "1395"},
        PORTUGUESE: {name: 'Portuguese', index: "3680"},
        ROMANIAN: {name: 'Romanian', index: "3684"},
        SLOVAK: {name: 'Slovak', index: "3692"},
        SLOVENIAN: {name: 'Slovenian', index: "3693"},
        SPANISH: {name: 'Spanish', index: "3617"},
        SWEDISH: {name: 'Swedish', index: "3702"}
    }), //Language
    ConcentrationRange: new EsEnums({
        one: {name: '> 0.1% w/w and < 0.3% w/w', index: "66279"},
        two: {name: '≥ 0.3% w/w and < 1.0% w/w', index: "66280"},
        three: {name: '≥ 1.0% w/w and < 10.0% w/w', index: "66281"},
        four: {name: '≥ 10.0% w/w and < 20.0% w/w', index: "66284"},
        five: {name: '≥ 20.0% w/w and < 100% w/w', index: "66285"},
        six: {name: '> 0.1% w/w and ≤ 100% w/w', index: "66286"}
    }), //Concentration range
    MaterialCategory: new EsEnums({

        66323: {
            "index": "66323",
            "name": "ceramic > clays / silicate ceramic"
        },
        66324: {
            "index": "66324",
            "name": "ceramic > clays / silicate ceramic > clays"
        },
        66325: {
            "index": "66325",
            "name": "ceramic > clays / silicate ceramic > earthenware"
        },
        66326: {
            "index": "66326",
            "name": "ceramic > clays / silicate ceramic > porcelain or china"
        },
        66327: {
            "index": "66327",
            "name": "ceramic > clays / silicate ceramic > stoneware"
        },
        66328: {
            "index": "66328",
            "name": "ceramic > clays / silicate ceramic > other"
        },
        66329: {
            "index": "66329",
            "name": "ceramic > oxide ceramic"
        },
        66330: {
            "index": "66330",
            "name": "ceramic > oxide ceramic > aluminium oxide ceramic"
        },
        66331: {
            "index": "66331",
            "name": "ceramic > oxide ceramic > aluminium titanate (ati) ceramic"
        },
        66332: {
            "index": "66332",
            "name": "ceramic > oxide ceramic > beryllium oxide ceramic"
        },
        66333: {
            "index": "66333",
            "name": "ceramic > oxide ceramic > ferroelectric perovskites based ceramic"
        },
        66334: {
            "index": "66334",
            "name": "ceramic > oxide ceramic > lead zirconium titanate (pzt) ceramic"
        },
        66335: {
            "index": "66335",
            "name": "ceramic > oxide ceramic > magnesium oxide ceramic"
        },
        66336: {
            "index": "66336",
            "name": "ceramic > oxide ceramic > magnesium titanate ceramic"
        },
        66337: {
            "index": "66337",
            "name": "ceramic > oxide ceramic > titanium dioxide ceramic"
        },
        66338: {
            "index": "66338",
            "name": "ceramic > oxide ceramic > zirconium oxide ceramic"
        },
        66339: {
            "index": "66339",
            "name": "ceramic > oxide ceramic > other"
        },
        66340: {
            "index": "66340",
            "name": "ceramic > non-oxide ceramic"
        },
        66341: {
            "index": "66341",
            "name": "ceramic > non-oxide ceramic > aluminium nitride ceramic"
        },
        66342: {
            "index": "66342",
            "name": "ceramic > non-oxide ceramic > boron carbide ceramic"
        },
        66343: {
            "index": "66343",
            "name": "ceramic > non-oxide ceramic > boron nitride ceramic"
        },
        66344: {
            "index": "66344",
            "name": "ceramic > non-oxide ceramic > silicon aluminium oxynitride (sialon)"
        },
        66345: {
            "index": "66345",
            "name": "ceramic > non-oxide ceramic > silicon carbide ceramic"
        },
        66346: {
            "index": "66346",
            "name": "ceramic > non-oxide ceramic > silicon nitride ceramic"
        },
        66347: {
            "index": "66347",
            "name": "ceramic > non-oxide ceramic > titanium nitride ceramic"
        },
        66348: {
            "index": "66348",
            "name": "ceramic > non-oxide ceramic > other"
        },
        66349: {
            "index": "66349",
            "name": "ceramic > frit"
        },
        66350: {
            "index": "66350",
            "name": "ceramic > refractory"
        },
        66351: {
            "index": "66351",
            "name": "glass > soda-lime glass"
        },
        66352: {
            "index": "66352",
            "name": "glass > lead crystal and crystal glass"
        },
        66353: {
            "index": "66353",
            "name": "glass > lead crystal and crystal glass > category no. 1 (annex i to directive 69/493/eec)"
        },
        66354: {
            "index": "66354",
            "name": "glass > lead crystal and crystal glass > category no. 2 (annex i to directive 69/493/eec)"
        },
        66355: {
            "index": "66355",
            "name": "glass > lead crystal and crystal glass > category no. 3 (annex i to directive 69/493/eec)"
        },
        66356: {
            "index": "66356",
            "name": "glass > lead crystal and crystal glass > category no. 4 (annex i to directive 69/493/eec)"
        },
        66357: {
            "index": "66357",
            "name": "glass > borosilicate glass"
        },
        66358: {
            "index": "66358",
            "name": "glass > fused quartz and fused silica glass"
        },
        66359: {
            "index": "66359",
            "name": "glass > optical glass"
        },
        66360: {
            "index": "66360",
            "name": "glass > sintered glass"
        },
        66361: {
            "index": "66361",
            "name": "glass > glass ceramic"
        },
        66362: {
            "index": "66362",
            "name": "glass > other special glass"
        },
        66363: {
            "index": "66363",
            "name": "leather and raw hides > leather"
        },
        66364: {
            "index": "66364",
            "name": "leather and raw hides > chamois leather"
        },
        66365: {
            "index": "66365",
            "name": "leather and raw hides > raw hides and skins"
        },
        66366: {
            "index": "66366",
            "name": "leather and raw hides > furskins"
        },
        66367: {
            "index": "66367",
            "name": "leather and raw hides > feathers"
        },
        66368: {
            "index": "66368",
            "name": "leather and raw hides > other material of animal origin, not specified elsewhere"
        },
        66369: {
            "index": "66369",
            "name": "metal > iron (and alloys of, except steel)"
        },
        66370: {
            "index": "66370",
            "name": "metal > iron (and alloys of, except steel) > iron, not alloyed"
        },
        66371: {
            "index": "66371",
            "name": "metal > iron (and alloys of, except steel) > ferro-alloy containing copper, except steel"
        },
        66372: {
            "index": "66372",
            "name": "metal > iron (and alloys of, except steel) > ferro-alloy containing tin, except steel"
        },
        66373: {
            "index": "66373",
            "name": "metal > iron (and alloys of, except steel) > other ferro-alloy, except steel"
        },
        66374: {
            "index": "66374",
            "name": "metal > steel"
        },
        66375: {
            "index": "66375",
            "name": "metal > steel > carbon steel (non-alloy steel)"
        },
        66376: {
            "index": "66376",
            "name": "metal > steel > stainless steel"
        },
        66377: {
            "index": "66377",
            "name": "metal > steel > alloy steel (except stainless steel)"
        },
        66378: {
            "index": "66378",
            "name": "metal > steel > containing copper"
        },
        66379: {
            "index": "66379",
            "name": "metal > steel > containing tin"
        },
        66380: {
            "index": "66380",
            "name": "metal > aluminium (and alloys of)"
        },
        66381: {
            "index": "66381",
            "name": "metal > aluminium (and alloys of) > aluminium, not alloyed"
        },
        66382: {
            "index": "66382",
            "name": "metal > aluminium (and alloys of) > aluminium alloy containing lithium"
        },
        66383: {
            "index": "66383",
            "name": "metal > aluminium (and alloys of) > other aluminium alloy"
        },
        66384: {
            "index": "66384",
            "name": "metal > antimony (and alloys of)"
        },
        66385: {
            "index": "66385",
            "name": "metal > bismuth (and alloys of)"
        },
        66386: {
            "index": "66386",
            "name": "metal > brass"
        },
        66387: {
            "index": "66387",
            "name": "metal > brass > containing bismuth"
        },
        66388: {
            "index": "66388",
            "name": "metal > bronze"
        },
        66389: {
            "index": "66389",
            "name": "metal > bronze > containing bismuth"
        },
        66390: {
            "index": "66390",
            "name": "metal > cadmium (and alloys of)"
        },
        66391: {
            "index": "66391",
            "name": "metal > cobalt (and alloys of)"
        },
        66392: {
            "index": "66392",
            "name": "metal > copper (and alloys of, except bronze and brass)"
        },
        66393: {
            "index": "66393",
            "name": "metal > copper (and alloys of, except bronze and brass) > copper, not alloyed"
        },
        66394: {
            "index": "66394",
            "name": "metal > copper (and alloys of, except bronze and brass) > copper-alloy containing bismuth, except bronze and brass"
        },
        66395: {
            "index": "66395",
            "name": "metal > copper (and alloys of, except bronze and brass) > other copper-alloy, except bronze and brass"
        },
        66396: {
            "index": "66396",
            "name": "metal > lead (and alloys of)"
        },
        66397: {
            "index": "66397",
            "name": "metal > lead (and alloys of) > lead, not alloyed"
        },
        66398: {
            "index": "66398",
            "name": "metal > lead (and alloys of) > lead alloy"
        },
        66399: {
            "index": "66399",
            "name": "metal > magnesium (and alloys of)"
        },
        66400: {
            "index": "66400",
            "name": "metal > manganese (and alloys of)"
        },
        66401: {
            "index": "66401",
            "name": "metal > molybdenum (and alloys of)"
        },
        66402: {
            "index": "66402",
            "name": "metal > nickel (and alloys of)"
        },
        66403: {
            "index": "66403",
            "name": "metal > nickel (and alloys of) > nickel, not alloyed"
        },
        66404: {
            "index": "66404",
            "name": "metal > nickel (and alloys of) > nickel alloy"
        },
        66405: {
            "index": "66405",
            "name": "metal > tantalum (and alloys of)"
        },
        66406: {
            "index": "66406",
            "name": "metal > tin (and alloys of), except bronze"
        },
        66407: {
            "index": "66407",
            "name": "metal > tin (and alloys of), except bronze > tin, not alloyed"
        },
        66408: {
            "index": "66408",
            "name": "metal > tin (and alloys of), except bronze > tin alloy, except bronze"
        },
        66409: {
            "index": "66409",
            "name": "metal > titanium (and alloys of)"
        },
        66410: {
            "index": "66410",
            "name": "metal > tungsten (and alloys of)"
        },
        66411: {
            "index": "66411",
            "name": "metal > zinc (and alloys of, except brass)"
        },
        66412: {
            "index": "66412",
            "name": "metal > zinc (and alloys of, except brass) > zinc, not alloyed"
        },
        66413: {
            "index": "66413",
            "name": "metal > zinc (and alloys of, except brass) > zinc alloy, except brass"
        },
        66414: {
            "index": "66414",
            "name": "metal > zirconium (and alloys of)"
        },
        66415: {
            "index": "66415",
            "name": "metal > other non-ferrous metal (and alloys of)"
        },
        66416: {
            "index": "66416",
            "name": "metal > other non-ferrous metal (and alloys of) > rare-earth (and alloys of)"
        },
        66417: {
            "index": "66417",
            "name": "metal > other non-ferrous metal (and alloys of) > precious-metal (and alloys of)"
        },
        66418: {
            "index": "66418",
            "name": "metal > other non-ferrous metal (and alloys of) > other"
        },
        66419: {
            "index": "66419",
            "name": "paper and board > printing and writing paper"
        },
        66420: {
            "index": "66420",
            "name": "paper and board > printing and writing paper > virgin pulp"
        },
        66421: {
            "index": "66421",
            "name": "paper and board > printing and writing paper > recovered pulp"
        },
        66422: {
            "index": "66422",
            "name": "paper and board > newsprint paper"
        },
        66423: {
            "index": "66423",
            "name": "paper and board > newsprint paper  > virgin pulp"
        },
        66424: {
            "index": "66424",
            "name": "paper and board > newsprint paper  > recovered pulp"
        },
        66425: {
            "index": "66425",
            "name": "paper and board > supercalendered (sc) paper"
        },
        66426: {
            "index": "66426",
            "name": "paper and board > supercalendered (sc) paper > virgin pulp"
        },
        66427: {
            "index": "66427",
            "name": "paper and board > supercalendered (sc) paper > recovered pulp"
        },
        66428: {
            "index": "66428",
            "name": "paper and board > ultra-light weight paper"
        },
        66429: {
            "index": "66429",
            "name": "paper and board > ultra-light weight paper > virgin pulp"
        },
        66430: {
            "index": "66430",
            "name": "paper and board > ultra-light weight paper > recovered pulp"
        },
        66431: {
            "index": "66431",
            "name": "paper and board > light weight paper"
        },
        66432: {
            "index": "66432",
            "name": "paper and board > light weight paper > virgin pulp"
        },
        66433: {
            "index": "66433",
            "name": "paper and board > light weight paper > recovered pulp"
        },
        66434: {
            "index": "66434",
            "name": "paper and board > medium weight paper"
        },
        66435: {
            "index": "66435",
            "name": "paper and board > medium weight paper > virgin pulp"
        },
        66436: {
            "index": "66436",
            "name": "paper and board > medium weight paper > recovered pulp"
        },
        66437: {
            "index": "66437",
            "name": "paper and board > high weight paper"
        },
        66438: {
            "index": "66438",
            "name": "paper and board > high weight paper > virgin pulp"
        },
        66439: {
            "index": "66439",
            "name": "paper and board > high weight paper > recovered pulp"
        },
        66440: {
            "index": "66440",
            "name": "paper and board > wood-free"
        },
        66441: {
            "index": "66441",
            "name": "paper and board > wood-free > virgin pulp"
        },
        66442: {
            "index": "66442",
            "name": "paper and board > wood-free > recovered pulp"
        },
        66443: {
            "index": "66443",
            "name": "paper and board > kraft paper and kraft wrapping"
        },
        66444: {
            "index": "66444",
            "name": "paper and board > kraft paper and kraft wrapping > virgin pulp"
        },
        66445: {
            "index": "66445",
            "name": "paper and board > kraft paper and kraft wrapping > recovered pulp"
        },
        66446: {
            "index": "66446",
            "name": "paper and board > tissue paper"
        },
        66447: {
            "index": "66447",
            "name": "paper and board > tissue paper > virgin pulp"
        },
        66448: {
            "index": "66448",
            "name": "paper and board > tissue paper > recovered pulp"
        },
        66449: {
            "index": "66449",
            "name": "paper and board > tracing paper"
        },
        66450: {
            "index": "66450",
            "name": "paper and board > tracing paper > virgin pulp"
        },
        66451: {
            "index": "66451",
            "name": "paper and board > tracing paper > recovered pulp"
        },
        66452: {
            "index": "66452",
            "name": "paper and board > carbonless paper"
        },
        66453: {
            "index": "66453",
            "name": "paper and board > carbonless paper > virgin pulp"
        },
        66454: {
            "index": "66454",
            "name": "paper and board > carbonless paper > recovered pulp"
        },
        66455: {
            "index": "66455",
            "name": "paper and board > carbon paper"
        },
        66456: {
            "index": "66456",
            "name": "paper and board > carbon paper > virgin pulp"
        },
        66457: {
            "index": "66457",
            "name": "paper and board > carbon paper > recovered pulp"
        },
        66458: {
            "index": "66458",
            "name": "paper and board > glassine/greaseproof paper"
        },
        66459: {
            "index": "66459",
            "name": "paper and board > glassine/greaseproof paper > virgin pulp"
        },
        66460: {
            "index": "66460",
            "name": "paper and board > glassine/greaseproof paper > recovered pulp"
        },
        66461: {
            "index": "66461",
            "name": "paper and board > fine paper"
        },
        66462: {
            "index": "66462",
            "name": "paper and board > fine paper  > virgin pulp"
        },
        66463: {
            "index": "66463",
            "name": "paper and board > fine paper  > recovered pulp"
        },
        66464: {
            "index": "66464",
            "name": "paper and board > filter paper"
        },
        66465: {
            "index": "66465",
            "name": "paper and board > filter paper > virgin pulp"
        },
        66466: {
            "index": "66466",
            "name": "paper and board > filter paper > recovered pulp"
        },
        66467: {
            "index": "66467",
            "name": "paper and board > thermal paper"
        },
        66468: {
            "index": "66468",
            "name": "paper and board > thermal paper > virgin pulp"
        },
        66469: {
            "index": "66469",
            "name": "paper and board > thermal paper > recovered pulp"
        },
        66470: {
            "index": "66470",
            "name": "paper and board > other speciality paper"
        },
        66471: {
            "index": "66471",
            "name": "paper and board > other speciality paper > virgin pulp"
        },
        66472: {
            "index": "66472",
            "name": "paper and board > other speciality paper > recovered pulp"
        },
        66473: {
            "index": "66473",
            "name": "paper and board > non-corrugated fibreboard"
        },
        66474: {
            "index": "66474",
            "name": "paper and board > non-corrugated fibreboard > virgin pulp"
        },
        66475: {
            "index": "66475",
            "name": "paper and board > non-corrugated fibreboard > recovered pulp"
        },
        66476: {
            "index": "66476",
            "name": "paper and board > corrugated fibreboard"
        },
        66477: {
            "index": "66477",
            "name": "paper and board > corrugated fibreboard > virgin pulp"
        },
        66478: {
            "index": "66478",
            "name": "paper and board > corrugated fibreboard > recovered pulp"
        },
        66479: {
            "index": "66479",
            "name": "paper and board > other paper (not elsewhere specified)"
        },
        66480: {
            "index": "66480",
            "name": "paper and board > other paper (not elsewhere specified) > virgin pulp"
        },
        66481: {
            "index": "66481",
            "name": "paper and board > other paper (not elsewhere specified) > recovered pulp"
        },
        66482: {
            "index": "66482",
            "name": "paper and board > other board (not elsewhere specified)"
        },
        66483: {
            "index": "66483",
            "name": "paper and board > other board (not elsewhere specified) > virgin pulp"
        },
        66484: {
            "index": "66484",
            "name": "paper and board > other board (not elsewhere specified) > recovered pulp"
        },
        66485: {
            "index": "66485",
            "name": "plastic (and polymers) > polyethylene, low density (ldpe)"
        },
        66486: {
            "index": "66486",
            "name": "plastic (and polymers) > polyethylene, high density (hdpe)"
        },
        66487: {
            "index": "66487",
            "name": "plastic (and polymers) > polypropylene (pp)"
        },
        66488: {
            "index": "66488",
            "name": "plastic (and polymers) > polyisobutylene"
        },
        66489: {
            "index": "66489",
            "name": "plastic (and polymers) > copolymers of ethylene-vinyl acetate"
        },
        66490: {
            "index": "66490",
            "name": "plastic (and polymers) > other copolymers of ethylene"
        },
        66491: {
            "index": "66491",
            "name": "plastic (and polymers) > copolymers of propylene"
        },
        66492: {
            "index": "66492",
            "name": "plastic (and polymers) > polymers and copolymers of olefins, not elsewhere specified"
        },
        66493: {
            "index": "66493",
            "name": "plastic (and polymers) > polyvinylchloride (pvc), hard"
        },
        66494: {
            "index": "66494",
            "name": "plastic (and polymers) > polyvinylchloride (pvc), soft"
        },
        66495: {
            "index": "66495",
            "name": "plastic (and polymers) > copolymers of vinyl chloride-vinyl acetate"
        },
        66496: {
            "index": "66496",
            "name": "plastic (and polymers) > other copolymers of vinyl chloride"
        },
        66497: {
            "index": "66497",
            "name": "plastic (and polymers) > polymers and copolymers of vinylidene chloride"
        },
        66498: {
            "index": "66498",
            "name": "plastic (and polymers) > fluoropolymers"
        },
        66499: {
            "index": "66499",
            "name": "plastic (and polymers) > polymers and copolymers of halogenated olefins, not elsewhere specified"
        },
        66500: {
            "index": "66500",
            "name": "plastic (and polymers) > polystyrene, expansible (eps)"
        },
        66501: {
            "index": "66501",
            "name": "plastic (and polymers) > polystyrene"
        },
        66502: {
            "index": "66502",
            "name": "plastic (and polymers) > copolymers of styrene-acrylonitrile (san)"
        },
        66503: {
            "index": "66503",
            "name": "plastic (and polymers) > copolymers of acrylonitrile-butadiene-styrene (abs)"
        },
        66504: {
            "index": "66504",
            "name": "plastic (and polymers) > brominated polystyrene"
        },
        66505: {
            "index": "66505",
            "name": "plastic (and polymers) > polymers and copolymers of styrene and its derivatives, not elsewhere specified"
        },
        66506: {
            "index": "66506",
            "name": "plastic (and polymers) > polyvinyl acetate (pva)"
        },
        66507: {
            "index": "66507",
            "name": "plastic (and polymers) > copolymers of vinyl acetate"
        },
        66508: {
            "index": "66508",
            "name": "plastic (and polymers) > poly(vinyl alcohol)"
        },
        66509: {
            "index": "66509",
            "name": "plastic (and polymers) > other polyvinyl esters and vinyl (co)polymers"
        },
        66510: {
            "index": "66510",
            "name": "plastic (and polymers) > poly(methyl methacrylate) (pmma)"
        },
        66511: {
            "index": "66511",
            "name": "plastic (and polymers) > polyacrylamides, including copolymers"
        },
        66512: {
            "index": "66512",
            "name": "plastic (and polymers) > other acrylic polymers and copolymers, not elsewhere specified"
        },
        66513: {
            "index": "66513",
            "name": "plastic (and polymers) > polyacetals, including copolymers"
        },
        66514: {
            "index": "66514",
            "name": "plastic (and polymers) > polyether alcohols, including copolymers"
        },
        66515: {
            "index": "66515",
            "name": "plastic (and polymers) > other polyethers, including copolymers"
        },
        66516: {
            "index": "66516",
            "name": "plastic (and polymers) > polycarbonates (pcs), including copolymers"
        },
        66517: {
            "index": "66517",
            "name": "plastic (and polymers) > poly(ethylene terephthalate) (pet), including copolymers"
        },
        66518: {
            "index": "66518",
            "name": "plastic (and polymers) > poly(lactic acid)"
        },
        66519: {
            "index": "66519",
            "name": "plastic (and polymers) > other polyesters, not elsewhere specified"
        },
        66520: {
            "index": "66520",
            "name": "plastic (and polymers) > polyimides"
        },
        66521: {
            "index": "66521",
            "name": "plastic (and polymers) > epoxide resins"
        },
        66522: {
            "index": "66522",
            "name": "plastic (and polymers) > alkyd resins"
        },
        66523: {
            "index": "66523",
            "name": "plastic (and polymers) > other polyallyl esters"
        },
        66524: {
            "index": "66524",
            "name": "plastic (and polymers) > other polyesters"
        },
        66525: {
            "index": "66525",
            "name": "plastic (and polymers) > polyamides, including copolymers"
        },
        66526: {
            "index": "66526",
            "name": "plastic (and polymers) > silicones (or polysiloxanes), including copolymers"
        },
        66527: {
            "index": "66527",
            "name": "plastic (and polymers) > urea and thiourea resins"
        },
        66528: {
            "index": "66528",
            "name": "plastic (and polymers) > melamine resins"
        },
        66529: {
            "index": "66529",
            "name": "plastic (and polymers) > other amino-resins"
        },
        66530: {
            "index": "66530",
            "name": "plastic (and polymers) > phenolic resins"
        },
        66531: {
            "index": "66531",
            "name": "plastic (and polymers) > polyurethanes"
        },
        66532: {
            "index": "66532",
            "name": "plastic (and polymers) > natural polymers, not elsewhere specified"
        },
        66533: {
            "index": "66533",
            "name": "plastic (and polymers) > modified natural polymers, not elsewhere specified"
        },
        66534: {
            "index": "66534",
            "name": "plastic (and polymers) > petroleum resins"
        },
        66535: {
            "index": "66535",
            "name": "plastic (and polymers) > coumarone, indene or coumarone-indene resins"
        },
        66536: {
            "index": "66536",
            "name": "plastic (and polymers) > polyterpenes"
        },
        66537: {
            "index": "66537",
            "name": "plastic (and polymers) > polysulphides and polysulphones"
        },
        66538: {
            "index": "66538",
            "name": "plastic (and polymers) > cellulose and its chemical derivatives (not elsewhere specified)"
        },
        66539: {
            "index": "66539",
            "name": "plastic (and polymers) > other non-halogenated (co)polymers"
        },
        66540: {
            "index": "66540",
            "name": "plastic (and polymers) > other halogenated (co)polymers"
        },
        66541: {
            "index": "66541",
            "name": "rubber and elastomers > natural rubber"
        },
        66542: {
            "index": "66542",
            "name": "rubber and elastomers > natural gums"
        },
        66543: {
            "index": "66543",
            "name": "rubber and elastomers > styrene-butadiene rubber (sbr)"
        },
        66544: {
            "index": "66544",
            "name": "rubber and elastomers > carboxylated styrene-butadiene rubber (xsbr)"
        },
        66545: {
            "index": "66545",
            "name": "rubber and elastomers > butadiene rubber (br)"
        },
        66546: {
            "index": "66546",
            "name": "rubber and elastomers > isobutene-isoprene (butyl) rubber (iir)"
        },
        66547: {
            "index": "66547",
            "name": "rubber and elastomers > halo-isobutene-isoprene rubber (ciir or biir)"
        },
        66548: {
            "index": "66548",
            "name": "rubber and elastomers > chloroprene (chlorobutadiene) rubber (cr)"
        },
        66549: {
            "index": "66549",
            "name": "rubber and elastomers > acrylonitrile-butadiene rubber (nbr)"
        },
        66550: {
            "index": "66550",
            "name": "rubber and elastomers > isoprene rubber (ir)"
        },
        66551: {
            "index": "66551",
            "name": "rubber and elastomers > ethylene propylene rubber (epr)"
        },
        66552: {
            "index": "66552",
            "name": "rubber and elastomers > chlorosuphonated polyethylene rubber (csm)"
        },
        66553: {
            "index": "66553",
            "name": "rubber and elastomers > fluoropolymer rubber"
        },
        66554: {
            "index": "66554",
            "name": "rubber and elastomers > ethylene-propylene-non-conjugated diene rubber (epdm)"
        },
        66555: {
            "index": "66555",
            "name": "rubber and elastomers > silicone rubber"
        },
        66556: {
            "index": "66556",
            "name": "rubber and elastomers > urethane rubber (pur)"
        },
        66557: {
            "index": "66557",
            "name": "rubber and elastomers > other halogenated rubber"
        },
        66558: {
            "index": "66558",
            "name": "rubber and elastomers > other rubber"
        },
        66559: {
            "index": "66559",
            "name": "rubber and elastomers > hard rubber (e.g. ebonite)"
        },
        66560: {
            "index": "66560",
            "name": "stone, plaster, and cement > stone (massive)"
        },
        66561: {
            "index": "66561",
            "name": "stone, plaster, and cement > precious and semi-precious stone and pearls"
        },
        66562: {
            "index": "66562",
            "name": "stone, plaster, and cement > plaster"
        },
        66563: {
            "index": "66563",
            "name": "stone, plaster, and cement > gypsum"
        },
        66564: {
            "index": "66564",
            "name": "stone, plaster, and cement > cement"
        },
        66565: {
            "index": "66565",
            "name": "stone, plaster, and cement > concrete"
        },
        66566: {
            "index": "66566",
            "name": "stone, plaster, and cement > expanded minerals"
        },
        66567: {
            "index": "66567",
            "name": "stone, plaster, and cement > artificial stone"
        },
        66568: {
            "index": "66568",
            "name": "stone, plaster, and cement > mica"
        },
        66569: {
            "index": "66569",
            "name": "stone, plaster, and cement > mineral agglomerates, grains, and particles"
        },
        66570: {
            "index": "66570",
            "name": "stone, plaster, and cement > stone or rock-wool"
        },
        66571: {
            "index": "66571",
            "name": "stone, plaster, and cement > slag-wool"
        },
        66572: {
            "index": "66572",
            "name": "stone, plaster, and cement > other mineral wools"
        },
        66573: {
            "index": "66573",
            "name": "stone, plaster, and cement > carbon fibres"
        },
        66574: {
            "index": "66574",
            "name": "stone, plaster, and cement > other minerals"
        },
        66575: {
            "index": "66575",
            "name": "textile fibre and other fibres > natural fibre of animal origin"
        },
        66576: {
            "index": "66576",
            "name": "textile fibre and other fibres > natural fibre of vegetable origin"
        },
        66577: {
            "index": "66577",
            "name": "textile fibre and other fibres > acetate (cellulose acetate fibre)"
        },
        66578: {
            "index": "66578",
            "name": "textile fibre and other fibres > alginate"
        },
        66579: {
            "index": "66579",
            "name": "textile fibre and other fibres > cupro (regenerated cellulose fibre)"
        },
        66580: {
            "index": "66580",
            "name": "textile fibre and other fibres > modal (regenerated cellulose fibre)"
        },
        66581: {
            "index": "66581",
            "name": "textile fibre and other fibres > protein (fibre obtained from)"
        },
        66582: {
            "index": "66582",
            "name": "textile fibre and other fibres > triacetate (cellulose acetate fibre)"
        },
        66583: {
            "index": "66583",
            "name": "textile fibre and other fibres > viscose (regenerated cellulose fibre)"
        },
        66584: {
            "index": "66584",
            "name": "textile fibre and other fibres > acrylic"
        },
        66585: {
            "index": "66585",
            "name": "textile fibre and other fibres > chlorofibre"
        },
        66586: {
            "index": "66586",
            "name": "textile fibre and other fibres > fluorofibre"
        },
        66587: {
            "index": "66587",
            "name": "textile fibre and other fibres > modacrylic"
        },
        66588: {
            "index": "66588",
            "name": "textile fibre and other fibres > polyamide or nylon"
        },
        66589: {
            "index": "66589",
            "name": "textile fibre and other fibres > aramid"
        },
        66590: {
            "index": "66590",
            "name": "textile fibre and other fibres > polyimide"
        },
        66591: {
            "index": "66591",
            "name": "textile fibre and other fibres > lyocell (regenerated cellulose fibre)"
        },
        66592: {
            "index": "66592",
            "name": "textile fibre and other fibres > polylactide"
        },
        66593: {
            "index": "66593",
            "name": "textile fibre and other fibres > polyester"
        },
        66594: {
            "index": "66594",
            "name": "textile fibre and other fibres > polyethylene"
        },
        66595: {
            "index": "66595",
            "name": "textile fibre and other fibres > polypropylene"
        },
        66596: {
            "index": "66596",
            "name": "textile fibre and other fibres > polycarbamide"
        },
        66597: {
            "index": "66597",
            "name": "textile fibre and other fibres > polyurethane"
        },
        66598: {
            "index": "66598",
            "name": "textile fibre and other fibres > vinylal"
        },
        66599: {
            "index": "66599",
            "name": "textile fibre and other fibres > trivinyl"
        },
        66600: {
            "index": "66600",
            "name": "textile fibre and other fibres > elastodiene"
        },
        66601: {
            "index": "66601",
            "name": "textile fibre and other fibres > elastane"
        },
        66602: {
            "index": "66602",
            "name": "textile fibre and other fibres > glass fibre (textile fibre)"
        },
        66603: {
            "index": "66603",
            "name": "textile fibre and other fibres > elastomultiester"
        },
        66604: {
            "index": "66604",
            "name": "textile fibre and other fibres > elastolefin"
        },
        66605: {
            "index": "66605",
            "name": "textile fibre and other fibres > melamine"
        },
        66606: {
            "index": "66606",
            "name": "textile fibre and other fibres > fibres obtained from miscellaneous or new materials not listed above (textile fibre), e.g. metal (metallic, metallised), paper"
        },
        66607: {
            "index": "66607",
            "name": "textile fibre and other fibres > polypropylene/polyamide bicomponent"
        },
        66608: {
            "index": "66608",
            "name": "textile fibre and other fibres > other synthetic fibres"
        },
        66609: {
            "index": "66609",
            "name": "wood and cork > wood (massive)"
        },
        66610: {
            "index": "66610",
            "name": "wood and cork > wood wool"
        },
        66611: {
            "index": "66611",
            "name": "wood and cork > wood fluor, sawdust"
        },
        66612: {
            "index": "66612",
            "name": "wood and cork > chipwood"
        },
        66613: {
            "index": "66613",
            "name": "wood and cork > wood fibres"
        },
        66614: {
            "index": "66614",
            "name": "wood and cork > forest residues"
        },
        66615: {
            "index": "66615",
            "name": "wood and cork > cork"
        },
        66616: {
            "index": "66616",
            "name": "wood and cork > straw"
        },
        66617: {
            "index": "66617",
            "name": "wood and cork > esparto"
        },
        66618: {
            "index": "66618",
            "name": "wood and cork > other plaiting materials"
        },
        66619: {
            "index": "66619",
            "name": "wood and cork > cane"
        },
        66620: {
            "index": "66620",
            "name": "wood and cork > other materials of vegetal origin, not specified elsewhere"
        },
        1342: {
            "index": "1342",
            "name": "other:"
        }
    }),
    MixCategrary: new EsEnums({
        64945: {
            "index": "64945",
            "name": "F Mixtures for further formulation"
        },
        64877: {
            "index": "64877",
            "name": "PC-ADH-1 Adhesives and sealants - household, office or school use"
        },
        64878: {
            "index": "64878",
            "name": "PC-ADH-2 Adhesives and sealants - building and construction works (except cement based adhesives)"
        },
        64879: {
            "index": "64879",
            "name": "PC-ADH-3 Adhesives and sealants - footwear and leather goods"
        },
        64880: {
            "index": "64880",
            "name": "PC-ADH-4 Adhesives and sealants - paper and board related processes"
        },
        64881: {
            "index": "64881",
            "name": "PC-ADH-5 Adhesives and sealants - transportation industry"
        },
        64882: {
            "index": "64882",
            "name": "PC-ADH-6 Adhesives and sealants -  woodworking and joinery (includes putty)"
        },
        64883: {
            "index": "64883",
            "name": "PC-ADH-7 Adhesives and sealants - assembly line processes"
        },
        64884: {
            "index": "64884",
            "name": "PC-ADH-8 Multi-component adhesives and sealants"
        },
        64886: {
            "index": "64886",
            "name": "PC-ADH-OTH Other adhesives and sealants"
        },
        64946: {
            "index": "64946",
            "name": "PC-AIR-1 Air care products for indoor rooms (continuous action)"
        },
        64947: {
            "index": "64947",
            "name": "PC-AIR-2 Air care products for indoor rooms (instant action)"
        },
        64948: {
            "index": "64948",
            "name": "PC-AIR-3 Air care products for shoes"
        },
        64949: {
            "index": "64949",
            "name": "PC-AIR-4 Air care products for vehicles"
        },
        64950: {
            "index": "64950",
            "name": "PC-AIR-5 Ambient deodorisers (excludes room deodorisers)"
        },
        64951: {
            "index": "64951",
            "name": "PC-AIR-6 Incense"
        },
        64952: {
            "index": "64952",
            "name": "PC-AIR-7 Candles - scented and unscented"
        },
        64953: {
            "index": "64953",
            "name": "PC-AIR-8 Matches"
        },
        64954: {
            "index": "64954",
            "name": "PC-AIR-OTH Other air care products"
        },
        64955: {
            "index": "64955",
            "name": "PC-ANI-1 Additives and premixtures for animal feed"
        },
        64956: {
            "index": "64956",
            "name": "PC-ANI-2 Animal shampoos and conditioners"
        },
        64957: {
            "index": "64957",
            "name": "PC-ANI-OTH Other products for animals (excluding biocidal products)"
        },
        64958: {
            "index": "64958",
            "name": "PC-ART-1 Artists’, craft and hobby paints"
        },
        64959: {
            "index": "64959",
            "name": "PC-ART-2 Finger paints"
        },
        64960: {
            "index": "64960",
            "name": "PC-ART-3 Crayons, chalks and pastels"
        },
        64961: {
            "index": "64961",
            "name": "PC-ART-4 Auxiliary materials for artists"
        },
        64962: {
            "index": "64962",
            "name": "PC-ART-5 Modelling compounds"
        },
        64963: {
            "index": "64963",
            "name": "PC-ART-6 Chemical products used for decorative purposes"
        },
        64964: {
            "index": "64964",
            "name": "PC-ART-OTH Other art  materials (including chemical products used for decorative purposes)"
        },
        64965: {
            "index": "64965",
            "name": "PC-CLN-1 Abrasive cleaning products"
        },
        64966: {
            "index": "64966",
            "name": "PC-CLN-2 All-purpose (or multi-purpose) non-abrasive cleaners"
        },
        64967: {
            "index": "64967",
            "name": "PC-CLN-3 Bleaching products for cleaning or laundry use (excludes biocidal products)"
        },
        64968: {
            "index": "64968",
            "name": "PC-CLN-4 Descaling products"
        },
        64969: {
            "index": "64969",
            "name": "PC-CLN-5 Drain cleaning products"
        },
        64970: {
            "index": "64970",
            "name": "PC-CLN-6 Fireplace and smoke resin cleaners"
        },
        64971: {
            "index": "64971",
            "name": "PC-CLN-7 Glass/window/mirror cleaning products (excludes windscreens)"
        },
        64972: {
            "index": "64972",
            "name": "PC-CLN-8 Indoor furniture cleaning/care products (excludes leather and upholstery)"
        },
        64973: {
            "index": "64973",
            "name": "PC-CLN-9 Outdoor cleaners (excludes stone, concrete and similar surfaces)"
        },
        64974: {
            "index": "64974",
            "name": "PC-CLN-10.1 Cleaners for kitchen areas"
        },
        64975: {
            "index": "64975",
            "name": "PC-CLN-10.2 Cleaners for kitchen machinery and equipment"
        },
        64976: {
            "index": "64976",
            "name": "PC-CLN-10.3 Cooking hob cleaning/care products"
        },
        64977: {
            "index": "64977",
            "name": "PC-CLN-10.4 Oven, grill or barbecue cleaners"
        },
        64978: {
            "index": "64978",
            "name": "PC-CLN-10.OTH Other kitchen and related cleaning products"
        },
        64979: {
            "index": "64979",
            "name": "PC-CLN-11.1 Bathroom cleaners"
        },
        64980: {
            "index": "64980",
            "name": "PC-CLN-11.2 Toilet cleaners"
        },
        64981: {
            "index": "64981",
            "name": "PC-CLN-11.3 Multi-flush products for toilets"
        },
        64982: {
            "index": "64982",
            "name": "PC-CLN-11.OTH Other bathroom and toilet cleaning/care products (excludes biocidal products)"
        },
        64983: {
            "index": "64983",
            "name": "PC-CLN-12.1 Cleaning/care products for stone and tiles - regular use"
        },
        64984: {
            "index": "64984",
            "name": "PC-CLN-12.2 Heavy duty cleaning products for stone and similar surfaces"
        },
        64985: {
            "index": "64985",
            "name": "PC-CLN-12.3 Grout cleaners"
        },
        64986: {
            "index": "64986",
            "name": "PC-CLN-12.OTH Other stone, tile and grout cleaning/care products"
        },
        64987: {
            "index": "64987",
            "name": "PC-CLN-13.1 Floor cleaning products"
        },
        65145: {
            "index": "65145",
            "name": "PC-CLN-13.2 Floor care products e.g. waxes, emulsions"
        },
        64988: {
            "index": "64988",
            "name": "PC-CLN-13.3 Floor strippers"
        },
        64990: {
            "index": "64990",
            "name": "PC-CLN-13.OTH Other floor cleaning, care and maintenance products (excludes stone and tile)"
        },
        64991: {
            "index": "64991",
            "name": "PC-CLN-14.1 Cleaning products for carpet/upholstery"
        },
        64992: {
            "index": "64992",
            "name": "PC-CLN-14.2 Deodorisers or fresheners for carpet/upholstery"
        },
        64993: {
            "index": "64993",
            "name": "PC-CLN-14.OTH Other carpet and upholstery products"
        },
        64994: {
            "index": "64994",
            "name": "PC-CLN-15.1 Cleaners for eyewear"
        },
        64995: {
            "index": "64995",
            "name": "PC-CLN-15.2 Cleaners for home electronic screens"
        },
        64996: {
            "index": "64996",
            "name": "PC-CLN-15.3 Cleaners for musical instruments"
        },
        64997: {
            "index": "64997",
            "name": "PC-CLN-15.4 Metal polish/tarnish remover"
        },
        64998: {
            "index": "64998",
            "name": "PC-CLN-15.OTH Other cleaners for specific personal items"
        },
        64999: {
            "index": "64999",
            "name": "PC-CLN-16.1 Leather - cleaning and care products"
        },
        65000: {
            "index": "65000",
            "name": "PC-CLN-16.2 Textile footwear - cleaning products"
        },
        65001: {
            "index": "65001",
            "name": "PC-CLN-16.3 Textile fresheners/deodorisers"
        },
        65002: {
            "index": "65002",
            "name": "PC-CLN-16.4 Dry cleaning and associated products"
        },
        65003: {
            "index": "65003",
            "name": "PC-CLN-16.5 Impregnation products for finished textiles and leather goods"
        },
        65004: {
            "index": "65004",
            "name": "PC-CLN-16.6 Outdoor textiles - cleaning products"
        },
        65005: {
            "index": "65005",
            "name": "PC-CLN-16.OTH Other textile and leather cleaning and care products (including footwear)"
        },
        65006: {
            "index": "65006",
            "name": "PC-CLN-17.1 Exterior cleaning products - all vehicle types"
        },
        65007: {
            "index": "65007",
            "name": "PC-CLN-17.2 Exterior care products -  all vehicle types"
        },
        65008: {
            "index": "65008",
            "name": "PC-CLN-17.3 Interior cleaning and care products (excludes air care products, and products for upholstery or leather)"
        },
        65009: {
            "index": "65009",
            "name": "PC-CLN-17.4 Engine cleaners"
        },
        65010: {
            "index": "65010",
            "name": "PC-CLN-17.5 Brake cleaners"
        },
        65011: {
            "index": "65011",
            "name": "PC-CLN-17.6 Chromium, rim and other metal cleaners -  all vehicle types"
        },
        65012: {
            "index": "65012",
            "name": "PC-CLN-17.7 Windscreen/windshield cleaners"
        },
        65013: {
            "index": "65013",
            "name": "PC-CLN-17.8 Windscreen/windshield wash fluid"
        },
        65014: {
            "index": "65014",
            "name": "PC-CLN-17.OTH Other vehicle (all types) cleaning and care products"
        },
        65015: {
            "index": "65015",
            "name": "PC-CLN-OTH Other cleaning, care and maintenance products (excludes biocidal products)"
        },
        65016: {
            "index": "65016",
            "name": "PC-COL-1 Dyes"
        },
        65017: {
            "index": "65017",
            "name": "PC-COL-2 Pigments"
        },
        65018: {
            "index": "65018",
            "name": "PC-CON-1 Cement"
        },
        65019: {
            "index": "65019",
            "name": "PC-CON-2 Concrete"
        },
        65020: {
            "index": "65020",
            "name": "PC-CON-3 Gypsum"
        },
        65021: {
            "index": "65021",
            "name": "PC-CON-4 Mortars"
        },
        65022: {
            "index": "65022",
            "name": "PC-CON-5 Construction chemicals"
        },
        65023: {
            "index": "65023",
            "name": "PC-CON-OTH Other construction products"
        },
        65024: {
            "index": "65024",
            "name": "PC-DET-1.1 Laundry detergent for hand washing"
        },
        65025: {
            "index": "65025",
            "name": "PC-DET-1.2 Laundry detergents - household use"
        },
        65026: {
            "index": "65026",
            "name": "PC-DET-1.3 Laundry detergents - professional or industrial use"
        },
        65027: {
            "index": "65027",
            "name": "PC-DET-1.OTH Other laundry detergents"
        },
        65028: {
            "index": "65028",
            "name": "PC-DET-2.1 Detergency boosters and in-wash stain removers"
        },
        65029: {
            "index": "65029",
            "name": "PC-DET-2.2 Fabric softeners"
        },
        65030: {
            "index": "65030",
            "name": "PC-DET-2.3 Ironing aid products"
        },
        65031: {
            "index": "65031",
            "name": "PC-DET-2.4 Laundry starch"
        },
        65032: {
            "index": "65032",
            "name": "PC-DET-2.5 Pre-treatment stain removers"
        },
        65033: {
            "index": "65033",
            "name": "PC-DET-2.6 Rinse agents for laundry (excludes biocidal products)"
        },
        65034: {
            "index": "65034",
            "name": "PC-DET-2.7 Washing machine care agents"
        },
        65035: {
            "index": "65035",
            "name": "PC-DET-2.8 Whitening agents or optical brighteners"
        },
        65036: {
            "index": "65036",
            "name": "PC-DET-2.OTH Other auxiliary laundry and care products (excludes biocidal products)"
        },
        65037: {
            "index": "65037",
            "name": "PC-DET-3.1 Automatic dishwashing detergents - household use"
        },
        65038: {
            "index": "65038",
            "name": "PC-DET-3.2 Automatic dishwashing detergents - professional or industrial use"
        },
        65039: {
            "index": "65039",
            "name": "PC-DET-3.3 Hand dishwashing detergents"
        },
        65040: {
            "index": "65040",
            "name": "PC-DET-3.OTH Other dishwashing detergents"
        },
        65041: {
            "index": "65041",
            "name": "PC-DET-4.1 Dishwasher salt"
        },
        65042: {
            "index": "65042",
            "name": "PC-DET-4.2 Dishwashing machine care agents"
        },
        65043: {
            "index": "65043",
            "name": "PC-DET-4.3 Glass protection products"
        },
        65044: {
            "index": "65044",
            "name": "PC-DET-4.4 Rinse agents for dishes"
        },
        65045: {
            "index": "65045",
            "name": "PC-DET-4.OTH Other auxiliary dishwashing and care products"
        },
        107824: {
            "index": "107824",
            "name": "PC-ELQ-1 E-liquids for electronic cigarettes"
        },
        107825: {
            "index": "107825",
            "name": "PC-ELQ-2 Mixtures for e-liquids"
        },
        65047: {
            "index": "65047",
            "name": "PC-FER-1 Fertilisers"
        },
        65048: {
            "index": "65048",
            "name": "PC-FER-2 Liming material"
        },
        65049: {
            "index": "65049",
            "name": "PC-FER-3 Soil improvers"
        },
        65050: {
            "index": "65050",
            "name": "PC-FER-4 Growing media"
        },
        65051: {
            "index": "65051",
            "name": "PC-FER-5 Agronomic additives"
        },
        65052: {
            "index": "65052",
            "name": "PC-FER-6 Plant biostimulants"
        },
        65053: {
            "index": "65053",
            "name": "PC-FER-7 Combination of fertilisers and fertilising products"
        },
        65054: {
            "index": "65054",
            "name": "PC-FUE-1 Fuels for vehicles and machinery"
        },
        65055: {
            "index": "65055",
            "name": "PC-FUE-2 Lamp oils"
        },
        65056: {
            "index": "65056",
            "name": "PC-FUE-3 Grill lighter fluids"
        },
        65057: {
            "index": "65057",
            "name": "PC-FUE-4 Camp fuels"
        },
        65058: {
            "index": "65058",
            "name": "PC-FUE-5 Fuel additives and fuel components"
        },
        65059: {
            "index": "65059",
            "name": "PC-FUE-OTH Other fuels"
        },
        65060: {
            "index": "65060",
            "name": "PC-INK-1 Writing and drawing inks"
        },
        65061: {
            "index": "65061",
            "name": "PC-INK-2 Inks and toners for home and office printers"
        },
        65062: {
            "index": "65062",
            "name": "PC-INK-3 Commercial printing inks, toners and related finishing products"
        },
        65063: {
            "index": "65063",
            "name": "PC-INK-4 Pressroom chemicals"
        },
        65064: {
            "index": "65064",
            "name": "PC-INK-5 Correction fluids"
        },
        65065: {
            "index": "65065",
            "name": "PC-INK-OTH Other inks, toners and related printing materials"
        },
        107826: {
            "index": "107826",
            "name": "PC-MED-1 Medical devices for cleaning or disinfection"
        },
        107827: {
            "index": "107827",
            "name": "PC-MED-OTH Other medical devices"
        },
        65066: {
            "index": "65066",
            "name": "PC-PNT-1 Aerosol paints and coatings"
        },
        65067: {
            "index": "65067",
            "name": "PC-PNT-2 Paints/coatings - Decorative"
        },
        65068: {
            "index": "65068",
            "name": "PC-PNT-3 Paints/coatings - Protective and functional"
        },
        65069: {
            "index": "65069",
            "name": "PC-PNT-4 Marine vessel coatings (excludes anti-fouling products)"
        },
        65070: {
            "index": "65070",
            "name": "PC-PNT-5 Automotive and aerospace coatings"
        },
        65071: {
            "index": "65071",
            "name": "PC-PNT-6 Factory-applied coatings (excludes categories already covered)"
        },
        65072: {
            "index": "65072",
            "name": "PC-PNT-7 Paint removers, thinners and related auxiliaries"
        },
        65073: {
            "index": "65073",
            "name": "PC-PNT-OTH Other paints and coating materials"
        },
        113222: {
            "index": "113222",
            "name": "PC-PYR Pyrotechnic products"
        },
        65079: {
            "index": "65079",
            "name": "PC-TAT Tattoo inks"
        },
        65080: {
            "index": "65080",
            "name": "PC-TEC-1 Adsorbents"
        },
        65081: {
            "index": "65081",
            "name": "PC-TEC-2 Antifreeze and de-icing products"
        },
        65082: {
            "index": "65082",
            "name": "PC-TEC-3 Desiccants"
        },
        65083: {
            "index": "65083",
            "name": "PC-TEC-4 Electrolytes for batteries"
        },
        65084: {
            "index": "65084",
            "name": "PC-TEC-5 Fire extinguishers"
        },
        65085: {
            "index": "65085",
            "name": "PC-TEC-6 Fragrances"
        },
        65086: {
            "index": "65086",
            "name": "PC-TEC-7 Heat transfer fluids"
        },
        65087: {
            "index": "65087",
            "name": "PC-TEC-8 Hydraulic fluids, including brake and transmission fluids"
        },
        65088: {
            "index": "65088",
            "name": "PC-TEC-9 Intermediates"
        },
        65089: {
            "index": "65089",
            "name": "PC-TEC-10 Leather treatment products (excludes dyes and pigments)"
        },
        65090: {
            "index": "65090",
            "name": "PC-TEC-11 Lubricants, greases, release agents"
        },
        65091: {
            "index": "65091",
            "name": "PC-TEC-12 Metal surface treatment products"
        },
        65092: {
            "index": "65092",
            "name": "PC-TEC-13 Metal working fluids"
        },
        65093: {
            "index": "65093",
            "name": "PC-TEC-14 Paper and board treatment products (excluding dyes)"
        },
        65094: {
            "index": "65094",
            "name": "PC-TEC-15 Photochemicals"
        },
        65095: {
            "index": "65095",
            "name": "PC-TEC-16 Polymer preparations and compounds"
        },
        65096: {
            "index": "65096",
            "name": "PC-TEC-17 Processing aids"
        },
        65097: {
            "index": "65097",
            "name": "PC-TEC-18 Products used in mining, oil or gas exploration processes"
        },
        65098: {
            "index": "65098",
            "name": "PC-TEC-19 Reagents and laboratory chemicals"
        },
        65099: {
            "index": "65099",
            "name": "PC-TEC-20 Soil remediation products"
        },
        65100: {
            "index": "65100",
            "name": "PC-TEC-21 Solvents and extraction agents"
        },
        65101: {
            "index": "65101",
            "name": "PC-TEC-22 Surfactants mixtures for industrial applications"
        },
        65102: {
            "index": "65102",
            "name": "PC-TEC-23 Textile treatment products (excludes dyes and pigments)"
        },
        65103: {
            "index": "65103",
            "name": "PC-TEC-24 Welding, soldering, and flux products"
        },
        107829: {
            "index": "107829",
            "name": "PC-TEC-25 Alloys"
        },
        129296: {
            "index": "129296",
            "name": "PC-TEC-26 Products for molding, casting, rigid and flexible foams, including resin mixtures (excludes adhesives, construction products, paints and coatings)"
        },
        129297: {
            "index": "129297",
            "name": "PC-TEC-27 Products for the polymerisation of resins and foams"
        },
        65104: {
            "index": "65104",
            "name": "PC-TEC-OTH Other products for  chemical or technical processes"
        },
        65105: {
            "index": "65105",
            "name": "PC-UNC Chemical products - uncategorised"
        },
        65106: {
            "index": "65106",
            "name": "PP-BIO-1 Biocidal products for human hygiene"
        },
        65107: {
            "index": "65107",
            "name": "PP-BIO-2 Disinfectants and algaecides not intended for direct application to humans or animals"
        },
        65108: {
            "index": "65108",
            "name": "PP-BIO-3 Biocidal products for veterinary hygiene"
        },
        65109: {
            "index": "65109",
            "name": "PP-BIO-4 Biocidal products for food and feed area"
        },
        65110: {
            "index": "65110",
            "name": "PP-BIO-5 Biocidal products for drinking water"
        },
        65111: {
            "index": "65111",
            "name": "PP-BIO-6 Biocidal products used as preservatives for products during storage"
        },
        65112: {
            "index": "65112",
            "name": "PP-BIO-7 Film preservatives"
        },
        65113: {
            "index": "65113",
            "name": "PP-BIO-8 Wood preservatives"
        },
        65114: {
            "index": "65114",
            "name": "PP-BIO-9 Fibre, leather, rubber and polymerised materials preservatives"
        },
        65115: {
            "index": "65115",
            "name": "PP-BIO-10 Construction material preservatives"
        },
        65116: {
            "index": "65116",
            "name": "PP-BIO-11 Preservatives for liquid-cooling and processing systems"
        },
        65117: {
            "index": "65117",
            "name": "PP-BIO-12 Slimicides"
        },
        65118: {
            "index": "65118",
            "name": "PP-BIO-13 Working or cutting fluid preservatives"
        },
        65119: {
            "index": "65119",
            "name": "PP-BIO-14 Rodenticides (excluding for plant protection)"
        },
        65120: {
            "index": "65120",
            "name": "PP-BIO-15 Avicides"
        },
        65121: {
            "index": "65121",
            "name": "PP-BIO-16 Molluscicides, vermicides and products to control other invertebrates (excluding plant protection products)"
        },
        65122: {
            "index": "65122",
            "name": "PP-BIO-17 Piscicides"
        },
        65123: {
            "index": "65123",
            "name": "PP-BIO-18 Insecticides, acaricides and products to control other arthropods (excluding equivalent products when used as pesticides)"
        },
        65124: {
            "index": "65124",
            "name": "PP-BIO-19 Repellents and attractants"
        },
        65125: {
            "index": "65125",
            "name": "PP-BIO-20 Control of other vertebrates"
        },
        65126: {
            "index": "65126",
            "name": "PP-BIO-21 Antifouling products"
        },
        65127: {
            "index": "65127",
            "name": "PP-BIO-22 Embalming and taxidermist fluids"
        },
        65128: {
            "index": "65128",
            "name": "PP-PRD-1 Acaricides for plant protection"
        },
        65129: {
            "index": "65129",
            "name": "PP-PRD-2 Attractants (excluding semio-chemicals)"
        },
        65130: {
            "index": "65130",
            "name": "PP-PRD-3 Bactericides for plant protection"
        },
        65131: {
            "index": "65131",
            "name": "PP-PRD-4 Biopesticides for plant protection"
        },
        65132: {
            "index": "65132",
            "name": "PP-PRD-5 Fungicides for plant protection"
        },
        65133: {
            "index": "65133",
            "name": "PP-PRD-6 Herbicides for plant protection, including haulm destructors and moss killers"
        },
        65134: {
            "index": "65134",
            "name": "PP-PRD-7 Insecticides for plant protection"
        },
        65135: {
            "index": "65135",
            "name": "PP-PRD-8 Molluscicides for plant protection"
        },
        65136: {
            "index": "65136",
            "name": "PP-PRD-9 Nematicides for plant protection"
        },
        65137: {
            "index": "65137",
            "name": "PP-PRD-10 Plant growth regulators"
        },
        65138: {
            "index": "65138",
            "name": "PP-PRD-11 Repellents for plant protection"
        },
        65139: {
            "index": "65139",
            "name": "PP-PRD-12 Rodenticides for plant protection"
        },
        65140: {
            "index": "65140",
            "name": "PP-PRD-13 Semio-chemicals"
        },
        65141: {
            "index": "65141",
            "name": "PP-PRD-14 Soil sterilants"
        },
        65142: {
            "index": "65142",
            "name": "PP-PRD-15 Talpicides for plant protection"
        },
        65143: {
            "index": "65143",
            "name": "PP-PRD-16 Viricides for plant protection"
        },
        65144: {
            "index": "65144",
            "name": "PP-PRD-OTH Other plant protection products and related mixtures"
        }
    }),
    YesOrNoEnum: new EsEnums({NO: {name: '否', index: 0}, YES: {name: '是', index: 1}}), //是否
    madeType: new EsEnums({METAL: {name: '金属', index: 'metal'}, NOMETAL: {name: '非金属', index: 'notMetal'}}), //是否
    YesOrNoType: new EsEnums({
        NO: {name: '否', index: 0},
        YES: {name: '是', index: 1},
        NOT_SURE: {name: '未确定', index: 2}
    }), //是否
    isQuery: new EsEnums({NO: {name: '缓存', index: 0}, YES: {name: '查库', index: 1}}), //查库还是缓存
    system: new EsEnums({CAMDS: {name: 'CAMDS', index: 0}, IMDS: {name: 'IMDS', index: 1}}), //系统类型
    status: new EsEnums({UN_AVAILABLE: {name: '否', index: 0}, AVAILABLE: {name: '是', index: 1}}), //状态类型
    checkType: new EsEnums({ERROR: {name: '错误', index: 0}, WARNING: {name: '警告', index: 1}}), //校验类型类型
    lawType: new EsEnums({
        INTERNATIONAL: {name: '国际标准', index: 0},
        ABROAD: {name: '国外标准', index: 1},
        DOMESTIC: {name: '国内标准', index: 2},
        ENTERPRISE: {name: '企业标准', index: 3},
        INDUSTRY: {name: '行业标准', index: 4}
    }), //法规类型
    anaMaterialMarkRule: new EsEnums({
        MM: {name: 'mM', index: 0},
        MTR: {name: 'mTr', index: 1},
        MTE: {name: 'mTe', index: 2},
        MN: {name: 'mN', index: 3},
        MP: {name: 'mP', index: 4}
    }), //标注阶段
    imdsType: new EsEnums({
        COMPONENT: {name: '零部件', index: 1},
        SEMICOMPONENT: {name: '半成品', index: 2},
        MATERIAL: {name: '材料', index: 3},
        MATTER: {name: "物质", index: 4}
    }),//审核表单类型
    CmdsType: new EsEnums({
        TOTal: {name: '全部', index: null},
        COMPONENT: {name: '零部件', index: 1},
        SEMICOMPONENT: {name: '半成品', index: 2},
        MATERIAL: {name: '材料', index: 3}
    }), //审核表单类型
    CmdsTypeSyn: new EsEnums({
        TOTal: {name: '全部', index: 0},
        COMPONENT: {name: '零部件', index: 1},
        SEMICOMPONENT: {name: '半成品', index: 2},
        MATERIAL: {name: '材料', index: 3}
    }), //审核表单类型
    fromSource: new EsEnums({TOTal: {name: '本企业创建', index: 0}, COMPONENT: {name: '供应商创建', index: 1},}), //表单来源
    fromSource2: new EsEnums({TOTal: {name: '本企业创建', index: 1}, COMPONENT: {name: '供应商创建', index: 0},}), //表单来源
    setflag: new EsEnums({ALL: {name: '全部', index: null}, HAS: {name: '有效', index: 0}, NO: {name: '无效', index: 1},}), //是否有效
    copyflag: new EsEnums({HAS: {name: '新版本', index: 1}, NO: {name: '拷贝', index: 0},}), //复制版本
    cauditStatus: new EsEnums({
        ALL: {name: '全部', index: null},
        NO_AUDIT: {name: '未审核', index: 0},
        ONE_AUDIT: {name: '审核中', index: 1},
        FINALLY_AUDIT: {name: '已批准', index: 2},
        REFUSE: {name: '已拒绝', index: 3}
    }), //是否有效
    queryDateType: new EsEnums({
        CREATE: {name: '创建时间', index: 1},
        UPDATE: {name: '更新时间', index: 2},
        RELEASE: {name: '发布时间', index: 3},
        AUDIT: {name: '批准时间', index: 4},
        RECEPTION: {name: '接收时间', index: 5}
    }), //查询时间
    queryDateType1: new EsEnums({CREATE: {name: '创建时间', index: 1}, UPDATE: {name: '更新时间', index: 2}}), //查询时间
    queryDateType2: new EsEnums({
        RELEASE: {name: '发布时间', index: 3},
        AUDIT: {name: '批准时间', index: 4},
        RECEPTION: {name: '接收时间', index: 5}
    }), //查询时间
    Corigin: new EsEnums({
        LOCAL: {name: '本地创建', index: 0},
        CAMDS: {name: 'CAMDS系统', index: 1},
        IMDS: {name: 'IMDS系统', index: 2}
    }), //数据来源
    cstatus: new EsEnums({
        ALL: {name: '全部', index: null},
        EDIT: {name: '编辑中', index: 'ED'},
        SUBMIT: {name: '已提交', index: 'ST'},
        SEND: {name: '已发送', index: 'SD'},
        INNER_PUBLIC: {name: '内部发布', index: 'IR'},
        PUBLIC: {name: '发布', index: 'RL'}
    }), //审核状态
    auditState: new EsEnums({PASS: {name: '通过', index: 2}, UN_PASS: {name: '拒绝', index: 3}}), //审核是否通过
    infoType: new EsEnums({
        PASS: {name: '错误', index: 0},
        UN_WARNING: {name: '警告', index: 1},
        UN_PASS: {name: '通过', index: 2},
        OTHER: {name: '其他', index: 3}
    }), //校验结果和错误类型信息
    searchInfoType: new EsEnums({
        ALL: {name: '全部', index: ""},
        PASS: {name: '错误', index: 0},
        UN_WARNING: {name: '警告', index: 1},
        UN_PASS: {name: '通过', index: 2}
    }), //校验结果和错误类型信息搜索
    downloadStatus: new EsEnums({
        ALL: {name: '全部', index: null},
        UN_DOWNLOAD: {name: '未下载', index: 0},
        DOWNLOAD: {name: '已下载', index: 1}
    }), //下载状态枚举
    dateType1: new EsEnums({
        ALL: {name: '全部时间', index: 0},
        CREATED: {name: '创建时间', index: 1},
        UPDATA: {name: '更新时间', index: 2}
    }), //查询时间枚举
    dateType2: new EsEnums({
        ALL: {name: '全部时间', index: 0},
        ISSUE: {name: '发布时间', index: 3},
        PASS: {name: '批准时间', index: 4},
        RECEPTION: {name: '接收时间', index: 5}
    }), //查询时间枚举
    recStatus: new EsEnums({
        ALL: {name: '全部', index: null},
        E: {name: '编辑模式', index: 'E'},
        N: {name: '尚未浏览', index: 'N'},
        S: {name: '已浏览', index: 'S'},
        D: {name: '已被下载', index: 'D'},
        P: {name: '已批准', index: 'P'},
        C: {name: '被发送人取消', index: 'C'},
        R: {name: '已拒绝', index: 'R'}
    }), //查询时间枚举
    roleAuthoritiesList: new EsEnums({
        ADMINISTRATION_AUTHORITY: {name: "管理权限", value: '0'},
        GENERAL_AUDIT_AUTHORITY: {name: "普通审核权限", value: '1'}
    }), // 角色信息数据权限
    selectType: new EsEnums({
        ERROR: {name: "下载错误信息", index: 1},
        LOG: {name: "下载记录", index: 2},
        RESULT: {name: "下载结果", index: 3},
        CHILDINFO: {name: "查询子表", index: 4}
    }), // 下载错误信息
    result: new EsEnums({ERROR: {name: "失败", index: 0}, SUCCESS: {name: "成功", index: 1}}), // 下载结果
    bomType: new EsEnums({formal: {name: "正式BOM", index: 0}, temporary: {name: "临时BOM", index: 1}}), // 车型信息类型
    modelType: new EsEnums({Traditional: {name: "传统车", index: 0}, newenergy: {name: "新能源车", index: 1}}), // 车型信息车型分类
    bomStatus: new EsEnums({no: {name: "不存在", index: 0}, yes: {name: "存在", index: 1}}), // 车型BOM信息BOM状态
    lockstatus: new EsEnums({no: {name: "未锁定", index: 0}, yes: {name: "锁定", index: 1}}), // 车型BOM信息锁定状态
    crateType: new EsEnums({
        RANGE: {name: "范围", index: '1'},
        FIXED_VALUE: {name: "固定值", index: '2'},
        SURPLUS: {name: "剩余", index: '3'}
    }), // 比例类型
    matching: new EsEnums({ALL: {name: "匹配全部节点", index: 1}, UN_MATCHING: {name: "只匹配未成功匹配节点", index: 2},}), // 比例类型
    lock: new EsEnums({LOCK: {name: "锁定", index: 1}, UN_LOCK: {name: "解锁", index: 0},}), // 比例类型
    chineseFlag: new EsEnums({CHINESE: {name: "是", index: 1}, UN_CHINESE: {name: "否", index: 0},}), // 比例类型
    analyseType: new EsEnums({LAWS: {name: "按法规分析", index: '按法规分析'}, ANALYSE: {name: "按物质分析", index: '按物质分析'},}), // 分析方式
    cnodeType: new EsEnums({
        A: {name: "零部件", index: '1'},
        B: {name: "半成品", index: '2'},
        C: {name: "材料", index: '3'},
        D: {name: "物质", index: '4'},
    }), // 分析方式
    queryType: new EsEnums({A: {name: "车型", index: 1}, B: {name: "零部件", index: 0}}), // 筛选类型
    modelId: new EsEnums({A: {name: "电动汽车", index: 1}, B: {name: "电动轿车", index: 2},}), // 车型信息
    lockType: new EsEnums({
        ALL: {name: "全部", index: null},
        LOCK: {name: "标注锁定", index: 1},
        UNLOCK: {name: "标注未锁定", index: 2},
    }), // 是否锁定
    matterColor: new EsEnums({
        BLACK: {name: "black", index: null},
        BLUE: {name: "blue", index: 'D'},
        RED: {name: "red", index: 'P'},
        RED2: {name: "red", index: 'D/P'}
    }), // 物质颜色
    crrrFlag: new EsEnums({
        MP: {name: "mP", index: "mP"},
        MD: {name: "mD", index: 'mD'},
        MM: {name: "mM", index: 'mM'},
        MTR: {name: "mTr", index: "mTr"},
        MTE: {name: "mTe", index: "mTe"},
        MN: {name: "mN", index: 'mN'}
    }), // 标注阶段
    isCar: new EsEnums({PART: {name: "零部件", index: 0}, CAR: {name: "车型", index: 1}}), // 标注阶段
    // reportSource: new EsEnums({
    //     ALL: {name: "全部", index: null},
    //     MATERIALS: {name: "整车材料分析", index: 1},
    //     PROHIBITED_SUBSTANCE: {name: "禁限用物质分析", index: 2},
    //     EXEMPT: {name: "禁限用物质豁免分析", index: 3},
    //     RRR_COUNT: {name: "整车RRR计算", index: 4},
    //     HIGH_RISK: {name: "高危清单管理", index: 5}
    // }), // 报告来源
    fileType: new EsEnums({
        NOTICE: {name: "公告文件", index: 1},
        SYSTEM: {name: "系统文件", index: 2},
        OTHER: {name: "其他", index: 3},
    }), // 文件类型
    addDataType: new EsEnums({
        NOTICE: {name: "零部件", index: 1},
        SYSTEM: {name: "半成品", index: 2},
        OTHER: {name: "材料", index: 3},
    }), // 本地数据新增类型
    syncResult: new EsEnums({
        ALL: {name: "全部", index: null},
        PANEL_HSYNC_BACK_PORCH: {name: "未同步", index: 0},
        SYN_SENT: {name: "已同步", index: 1},
    }), // imds审核同步信息
    operationFlag: new EsEnums({
        DEFAULT: {name: "默认", index: 0},
        LINK: {name: "挂接", index: 1},
        ADDMATERIALS: {name: "新建材料", index: 2},
        SWAP_PART: {name: "零部件", index: 3},
        SWAP_BLANK: {name: "半成品", index: 4},
        SWAP_MATERIALS: {name: "材料", index: 5},
        MODULE: {name: "组件", index: 6},
        BLANK_MODULE: {name: "半成品组件", index: 7},
        CQC_LINK: {name: "CQC挂接", index: 8},
    }), // 本地数据管理状态
    activeName: new EsEnums({
        CAMDS: {name: "first", index: 1},
        IMDS: {name: "second", index: 2},
        LOCAL: {name: "third", index: 0},
    }), // bom挂接类数据型
    taskState: new EsEnums({
        ALL: {name: "全部", index: null},
        PENDING: {name: "待处理", index: 0},
        DEAL: {name: "已处理", index: 1},
        NO_TASK: {name: "非任务", index: 2}
    }), // 任务状态
    // 0待处理 1已处理 2非任务 全部不传或者传null
    reportSource: new EsEnums({
        HIGH_RISK_LIST: {name: "高危清单", index: 1},
        VEHICLE_MATERIAL_ANALYSIS: {name: "整车材料明细", index: 2},
        ANALYSIS_OF_PROHIBITED: {name: "禁限用物质分析", index: 3},
        ANALYSIS_OF_PROHIBITED_PROHIBITED: {name: "禁限用物质豁免分析", index: 4},
        RRR: {name: "整车RRR计算", index: 5},
        MATERIAL_CLASSIFICATION: {name: "材料分类", index: 6},
        VEHICLE_DEVIATION: {name: "整车偏差分析", index: 7},
    }), // bom挂接类数据型
    matchingRule: new EsEnums({
        IMDS: {name: "IMDS", index: 0},
        CAMDS: {name: "CAMDS", index: 2},
        CAMDS_IMDS: {name: "CAMDS+IMDS", index: 3},
        IMDS_CAMDS: {name: "IMDS+CAMDS", index: 4}
    }), // bom匹配数据源
    powerPlantId: new EsEnums({
        A: {name: "插电式混合动力", index: 1},
        B: {name: "纯电动", index: 2},
        C: {name: "混合动力", index: 3},
        D: {name: "燃料电池", index: 4},
        E: {name: "内燃机", index: 5}
    }), // 动力形式
    banner_icon: new EsEnums({
        ICON_1: {name: "@/assets/images/banner_icon/banner_icon1.png", index: 1},
        ICON_2: {name: "@/assets/images/banner_icon/banner_icon1.png", index: 2},
        ICON_3: {name: "@/assets/images/banner_icon/banner_icon1.png", index: 3},
        ICON_4: {name: "@/assets/images/banner_icon/banner_icon1.png", index: 4}
    }), // 公告图标
    viewIsLock: new EsEnums({LOCK: {name: "不开放", index: 1}, UN_LOCK: {name: "开放", index: 0}}), // 车型数据状态锁定
    anaResultType: new EsEnums({
        ALL: {name: "全部", index: ''},
        A: {name: "〇", index: '〇'},
        B: {name: '╳', index: '╳'},
        C: {name: '√', index: '√'},
        D: {name: '△', index: '△'}
    }), // 车型数据状态锁定
    SCIPother: new EsEnums({
        A: {name: "选择/取消选择全部", index: "Select/Deselect all"},
        B: {name: "漂白", index: 'bleached'},
        C: {name: "棕色玻璃", index: 'brown glass '},
        D: {name: "涂层", index: 'coated'},
        E: {name: "有色的", index: 'coloured'},
        F: {name: "复合材料", index: 'composite material'},
        G: {name: "复合（其他）", index: 'compounded(other)'},
        H: {name: "与炭黑或二氧化硅复合", index: 'compounded with carbon black or silica'},
        I: {name: "地壳", index: 'crust'},
        J: {name: "搪瓷的", index: 'enamelled'},
        K: {name: "纤维", index: 'fibres'},
        L: {name: "平板玻璃", index: 'flat glass'},
        M: {name: "泡沫橡胶", index: 'foam'},
        N: {name: "玻璃棉", index: 'glass wool'},
        O: {name: "光滑的", index: 'glazed'},
        P: {name: "绿色玻璃", index: 'green glass'},
        R: {name: "浸渍或处理（其他添加剂化学处理）", index: 'impregnated or treated(other additive chenical treatment)'},
        S: {name: "叠层的", index: 'laminated'},
        T: {name: "乳胶", index: 'latex'},
        U: {name: "金属玻璃", index: 'metallic glass'},
        V: {name: "金属化皮革", index: 'metallised leather'},
        W: {name: "微球和颗粒", index: 'microspheres and particles'},
        X: {name: "无釉", index: 'non-glazed'},
        Y: {name: "其他彩色玻璃", index: 'other coloured glass'},
        Z: {name: "漆皮", index: 'patent leather'},
        ZA: {name: "镀", index: 'plated'},
        ZB: {name: "聚电解质", index: 'polyelectrolyte'},
        ZC: {name: "恢复", index: 'recovered'},
        ZD: {name: "硅化硫化", index: 'siliconated vulcanised'},
        ZE: {name: "热塑性塑料", index: 'thermoplastic'},
        ZF: {name: "热固性", index: 'thermoset'},
        ZG: {name: "未漂白", index: 'unbleached'},
        ZH: {name: "无涂层", index: 'uncoated'},
        ZI: {name: "未着色", index: 'uncoloured'},
        ZJ: {name: "玻璃化", index: 'vitrified'},
        ZK: {name: "硫化（其他）", index: 'vulcanised(other)'},
        ZL: {name: "水溶性聚合物", index: 'water-soluble polymer'},
        ZM: {name: "其他：", index: 'other:'}
    }), // 车型数据状态锁定
}


export default Enum
